/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { AngularFireAction, DatabaseSnapshot } from '@angular/fire/compat/database';

import { Plan, PlanFields } from '@touchplan/common';
import { FancyFirebaseSplitDataList } from '../generics/FancyFirebaseSplitDataList';
import { BehaviorSubject } from 'rxjs';
import { DefaultSplitDataRenderType } from '@touchplan/common';
import { AngularLandConnection, RefOrObservable } from '../base/interfaces';
import { IFancyIdJoin } from '../base/FancyIdJoin';
import { PlanAccess } from 'src/app/app-data/models/PlanAccess';

export class PlanList
	extends FancyFirebaseSplitDataList<PlanFields, DefaultSplitDataRenderType, Plan>
	implements IFancyIdJoin
{
	public editList$: BehaviorSubject<Map<string, Plan>> = new BehaviorSubject(new Map());

	constructor(angularLand: AngularLandConnection, path: RefOrObservable, fancyJoins?: any) {
		//fix any's
		super(angularLand, path, fancyJoins);

		const ob$ = this.makeSimpleSublist(DefaultSplitDataRenderType.edit);
		this.subscriptions.push(ob$.subscribe(this.editList$));
	}

	public $$added(action: AngularFireAction<DatabaseSnapshot<any>>) {
		const plan = new Plan(action.payload.key);
		const planData = action.payload.val() as PlanFields;
		plan.databaseUpdate(planData);
		return plan;
	}

	//put in interface so you can explicitly say you're doing this
	public applyJoinData(baseKey: string, child: Plan, otherChild: any) {
		if (baseKey === '$id' && otherChild instanceof PlanAccess) {
			child.localUpdate({ planAccess: otherChild.view });
		}
	}

	public getDataForKey(baseKey: string, child: Plan) {
		return child.$id;
	}
}
